import { render, staticRenderFns } from "./DeliveryStatusSignUI.vue?vue&type=template&id=5a537bdc&scoped=true&"
import script from "./DeliveryStatusSignUI.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatusSignUI.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStatusSignUI.vue?vue&type=style&index=0&id=5a537bdc&lang=sass&scoped=true&"
import style1 from "./DeliveryStatusSignUI.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a537bdc",
  null
  
)

export default component.exports